// Toggles `.sticky` on #header-component once the user scrolls past its initial offset.
// Loaded as a module from snippets/scripts.liquid — naturally deferred, no DOMContentLoaded
// wrapper needed.

const header = document.getElementById('header-component');

if (header) {
  const stickyOffset = header.offsetTop;

  window.addEventListener(
    'scroll',
    () => {
      if (window.pageYOffset > stickyOffset) {
        header.classList.add('sticky');
      } else {
        header.classList.remove('sticky');
      }
    },
    { passive: true }
  );
}
